

























































































































































import { Mixins } from "vue-mixin-decorator";
import { Component, Watch, Prop } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import GeneralMixin from "@/mixin";
import { ISiteListRequest, ISite } from "@/types/site";
import { IPagination } from "@/types";
import Search from "@/components/admin/forms/Search.vue";

@Component({
  components: {
    Search
  }
})
export default class extends Mixins<GeneralMixin>(GeneralMixin) {
  @Action("site/adminGetList")
  public adminGetList!: (request: ISiteListRequest) => boolean;

  @Getter("site/list")
  public siteList!: ISite[];

  @Getter("site/pagination")
  public pagination!: IPagination<ISite>;

  @Watch("$route.query")
  public async changeQuery() {
    this.queryToParams();
    await this.adminGetList(this.params);
  }

  @Prop({ default: false })
  public is_billed!: boolean;

  @Mutation("site/clear")
  public clear!: () => void;

  //
  // variables
  //
  public menu = {
    before: false,
    after: false
  };

  public headers = [
    { text: "現場名", value: "name", sortable: false },
    { text: "住所", value: "address", sortable: false },
    { text: "元請け", value: "contractor.name", sortable: false },
    // { text: "担当者", value: "user.name", sortable: false },
    { text: "着工日", value: "span_start", sortable: false },
    { text: "実働日数", value: "work_days", sortable: false },
    { text: "進行状況", value: "is_completion", sortable: false },
    { text: "経費入力", value: "input_completed", sortable: false }
  ];
  public params: ISiteListRequest = {
    status: 1,
    input_completed: 0,
    is_billed: false,
    search: "",
    address: "",
    mix: "",
    page: 1,
    search_span_end_before: "",
    search_span_end_after: ""
  };

  public statusList = [
    { value: 1, text: "全て" },
    { value: 2, text: "進行中のみ" },
    { value: 3, text: "完了のみ" }
  ];

  public inputStatusList = [
    { value: 0, text: "全て" },
    { value: 2, text: "入力中のみ" },
    { value: 1, text: "完了のみ" }
  ];

  //
  // methods
  //
  private async created() {
    this.clear();
    this.queryToParams();
    this.params.is_billed = this.is_billed;
    await this.adminGetList(this.params);
  }

  // urlからパラメータをセットする
  // $router -> params
  private queryToParams() {
    const query = this.$route.query;
    this.params = {
      search_span_end_before: query.search_span_end_before
        ? decodeURI(query.search_span_end_before as string)
        : "",
      search_span_end_after: query.search_span_end_after
        ? decodeURI(query.search_span_end_after as string)
        : "",

      search: query.search ? decodeURI(query.search as string) : "",
      address: query.address ? decodeURI(query.address as string) : "",
      mix: query.mix ? decodeURI(query.mix as string) : "",
      status: query.status ? Number(query.status) : 1,
      is_billed: query.is_billed === "true",
      input_completed: query.input_completed
        ? Number(query.input_completed)
        : 0,
      page: query.page ? Number(query.page) : 1
    };
  }

  // 1ページ目から検索
  // 主に検索条件が変更されたときに利用
  public async searchFirst() {
    this.params.page = 1;
    await this.paramsToQuery();
  }

  // URLのパラメータをセットする
  // params -> $router
  public paramsToQuery() {
    this.$router
      .push({
        path: this.$router.currentRoute.path,
        query: {
          search: this.params.search,
          address: this.params.address,
          mix: this.params.mix,
          status: this.params.status ? String(this.params.status) : "1",
          input_completed: !!this.params.input_completed
            ? String(this.params.input_completed)
            : "0",
          is_billed: String(this.params.is_billed),
          page: this.params.page ? String(this.params.page) : "1",
          search_span_end_before: this.params.search_span_end_before,
          search_span_end_after: this.params.search_span_end_after
        }
      })
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      .catch(() => {});
  }

  public rowClick(site: ISite) {
    this.$router.push(`/admin/site/${site.id}`);
  }

  public clearSearchBefore() {
    this.params.search_span_end_before = "";
    this.searchFirst();
  }
  public clearSearchAfter() {
    this.params.search_span_end_after = "";
    this.searchFirst();
  }
}
